import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';

import { InsightAccordion } from './components/insight-accordion/insight-accordion';
import { GrowthMetricCards } from './components/growth-metric-card/growth-metric-cards';
import { InsightRecommendations } from './components/insight-recommendation/insight-recommendations';
import { TabDisclaimer } from './tab-disclaimer';
import { MappedInsight } from './mappers/types';

interface InsightsTabProps {
  insights: MappedInsight[];
}

export const InsightsTab = ({ insights }: InsightsTabProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="16px">
      {insights.map((insight, index) => (
        <InsightAccordion
          key={index}
          variant={insight.variant}
          category={insight.category}
          scoreDelta={insight.scoreDelta}
        >
          <Typography fontSize="14px" fontWeight="400" lineHeight="150%" mb={0} color="rgba(0,0,0,0.55)">
            {insight.description}
          </Typography>

          <GrowthMetricCards metrics={insight.metrics} />

          <InsightRecommendations recommendations={insight.recommendations} />
        </InsightAccordion>
      ))}

      <TabDisclaimer />
    </Box>
  );
};
